import React from 'react';
import {
  Modal,
  Select,
  Card,
  Descriptions,
} from 'antd';

const { Option } = Select;

/**
 * PhoneSelectionModal Component
 * Reusable modal for selecting country and phone number for manual calls
 * 
 * Props:
 * - visible: boolean - Controls modal visibility
 * - onCancel: function - Called when modal is cancelled
 * - onConfirm: function - Called when user confirms selection
 * - callSettings: object - Call settings with countries and phone numbers
 * - selectedCountryIndex: number - Currently selected country index
 * - onCountryChange: function - Called when country selection changes
 * - selectedPhoneIndex: number - Currently selected phone index
 * - onPhoneChange: function - Called when phone selection changes
 * - loading: boolean - Show loading state on confirm button
 */
const PhoneSelectionModal = ({
  visible,
  onCancel,
  onConfirm,
  callSettings,
  selectedCountryIndex,
  onCountryChange,
  selectedPhoneIndex,
  onPhoneChange,
  loading = false,
}) => {
  const selectedCountry = callSettings?.plivoSettings?.countries?.[selectedCountryIndex];

  return (
    <Modal
      title="Select Phone Number for Call"
      open={visible}
      onCancel={onCancel}
      onOk={onConfirm}
      okText="Make Call"
      cancelText="Cancel"
      width={600}
      confirmLoading={loading}
    >
      <div style={{ marginBottom: '20px' }}>
        <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
          Select Country:
        </label>
        <Select
          value={selectedCountryIndex}
          onChange={(value) => {
            onCountryChange(value);
          }}
          style={{ width: '100%' }}
        >
          {callSettings?.plivoSettings?.countries?.map((country, index) => (
            <Option key={index} value={index}>
              {country.countryName} ({country.countryCode})
            </Option>
          ))}
        </Select>
      </div>

      {selectedCountry && (
        <div>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
            Select Phone Number:
          </label>
          <Select
            value={selectedPhoneIndex}
            onChange={onPhoneChange}
            style={{ width: '100%' }}
          >
            {selectedCountry.phoneNumbers?.map((phone, index) => (
              <Option key={index} value={index}>
                {phone}
              </Option>
            ))}
          </Select>

          {/* Display selected country details */}
          <Card
            style={{ marginTop: '16px', backgroundColor: '#f5f5f5' }}
            size="small"
          >
            <Descriptions column={1} size="small">
              <Descriptions.Item label="Country">
                {selectedCountry.countryName}
              </Descriptions.Item>
              <Descriptions.Item label="Country Code">
                {selectedCountry.countryCode}
              </Descriptions.Item>
              <Descriptions.Item label="Selected Phone">
                {selectedCountry.phoneNumbers?.[selectedPhoneIndex]}
              </Descriptions.Item>
            </Descriptions>
          </Card>
        </div>
      )}
    </Modal>
  );
};

export default PhoneSelectionModal;
